import { Loader2 } from 'lucide-react';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useMedia } from '@/queries/useMedia';

const MediaRedirect = () => {
  const { id } = useParams();
  const { data: media, isLoading } = useMedia(id);

  useEffect(() => {
    if (media && !media.content_type.startsWith('video')) {
      window.location.href = media.presigned_url;
    }
  }, [media]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-full">
        <Loader2 className="animate-spin" />
      </div>
    );
  }

  return (
    <div className="w-full max-w-3xl mx-auto p-4">
      <video controls className="w-full rounded-md shadow-md">
        <source src={media?.presigned_url} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default MediaRedirect;
